import Image from "next/image";
import Link from "next/link";
import { Heading } from "@/components/ui/Heading";
import { BannerData } from "@/core/types/about-us";
import CustomButton from "./CustomButton";
import FullWidth from "@/components/shared/FullWidth";

interface BannerProps {
  data: BannerData;
}

export default function Banner({ data }: BannerProps) {
  return (
    <FullWidth className="relative max-h-[70vh] aspect-video overflow-hidden">
      {data.image && (
        <Image
          src={data.image?.url}
          alt={data.title || "some picture"}
          className="w-full h-full object-cover"
          fill
        />
      )}
      <div className="absolute inset-0 bg-black/40 flex items-center">
        <div className="w-full lg:w-[48%] flex flex-col space-y-1 px-12">
          <Heading
            level={1}
            className="text-white text-[calc(.8rem+0.3vw)]"
          >
            {data.title}
          </Heading>
          <p className="text-white/90 text-sm">
            {data?.subtitle}
          </p>
          <p className="text-white/90 text-xs">
            {data?.description}
          </p>
          {(data.buttonContent && data.link) && (
            <div className="mt-2">
              <CustomButton asChild>
                <Link href={data.link}>{data.buttonContent}</Link>
              </CustomButton>
            </div>
          )}
        </div>
      </div>
    </FullWidth>
  );
}